
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSignMeetingPointSimple as ObiSignMeetingPointSimpleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-sign-meeting-point-simple.js';
 
 
 

 
 export const ObiSignMeetingPointSimple = createComponent({
   react: React,
   tagName: 'obi-sign-meeting-point-simple',
   elementClass: ObiSignMeetingPointSimpleElement,
   events: {
     
   }
  });
 
 